var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"detailLayout"},[_c('el-card',{staticClass:"main-el-card"},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._t("head")],2),_vm._t("Form"),_c('br'),_c('div',{staticClass:"buttons"},[_vm._t("buttons")],2)],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }